import React, { useState, useEffect } from 'react';
import { FaPlus, FaTrash, FaEdit, FaClock, FaUniversity } from 'react-icons/fa';
import API_BASE_URL from '../../config/api';

const ManageSchedules = () => {
  const [institutes, setInstitutes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showInstModal, setShowInstModal] = useState(false);
  const [showSchedModal, setShowSchedModal] = useState(false);
  const [currentInst, setCurrentInst] = useState(null);
  const [currentSched, setCurrentSched] = useState(null);
  const [instForm, setInstForm] = useState({ name: '', location: '', type: 'physical', sort_order: 0, logo_url: '' });
  const [schedForm, setSchedForm] = useState({ institute_id: '', session_code: '', class_segment: '', class_day: '', time_window: '' });

  const fetchData = async () => {
    setLoading(true);
    try {
      const res = await fetch(`${API_BASE_URL}/admin/manage_schedules.php?action=list`);
      const data = await res.json();
      if (data.status === 'success') setInstitutes(data.data);
    } catch (err) {
      console.error(err);
    }
    setLoading(false);
  };

  useEffect(() => { fetchData(); }, []);

  const handleSaveInst = async (e) => {
    e.preventDefault();
    try {
      const res = await fetch(`${API_BASE_URL}/admin/manage_schedules.php?action=save_institute`, {
        method: 'POST',
        body: JSON.stringify(instForm)
      });
      const data = await res.json();
      if (data.status === 'success') {
        setShowInstModal(false);
        fetchData();
      }
    } catch (err) { console.error(err); }
  };

  const handleSaveSched = async (e) => {
    e.preventDefault();
    try {
      const res = await fetch(`${API_BASE_URL}/admin/manage_schedules.php?action=save_schedule`, {
        method: 'POST',
        body: JSON.stringify(schedForm)
      });
      const data = await res.json();
      if (data.status === 'success') {
        setShowSchedModal(false);
        fetchData();
      }
    } catch (err) { console.error(err); }
  };

  const deleteInst = async (id) => {
    if (!window.confirm('Delete this institute and all its schedules?')) return;
    try {
      await fetch(`${API_BASE_URL}/admin/manage_schedules.php?action=delete_institute`, {
        method: 'POST',
        body: JSON.stringify({ id })
      });
      fetchData();
    } catch (err) { console.error(err); }
  };

  const deleteSched = async (id) => {
    if (!window.confirm('Delete this schedule item?')) return;
    try {
      await fetch(`${API_BASE_URL}/admin/manage_schedules.php?action=delete_schedule`, {
        method: 'POST',
        body: JSON.stringify({ id })
      });
      fetchData();
    } catch (err) { console.error(err); }
  };

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <h2 className="text-xl font-bold text-slate-800">Manage Portals & Schedules</h2>
        <button 
          onClick={() => { setInstForm({ name: '', location: '', type: 'physical', sort_order: institutes.length + 1, logo_url: '' }); setShowInstModal(true); }}
          className="bg-orange-500 text-white px-4 py-2 rounded-lg text-sm font-bold flex items-center gap-2"
        >
          <FaPlus /> Add Institute
        </button>
      </div>

      {loading ? (
        <div className="text-center py-12">Loading...</div>
      ) : (
        <div className="grid grid-cols-1 gap-8">
          {institutes.map(inst => (
            <div key={inst.id} className="bg-white border border-slate-200 rounded-2xl overflow-hidden shadow-sm">
              <div className="bg-slate-50 p-4 border-b border-slate-200 flex justify-between items-center">
                <div className="flex items-center gap-4">
                  <div className="w-10 h-10 bg-white rounded border flex items-center justify-center font-bold text-orange-500">
                    {inst.name[0]}
                  </div>
                  <div>
                    <h3 className="font-bold text-slate-800">{inst.name}</h3>
                    <p className="text-xs text-slate-500 uppercase tracking-wider">{inst.location} • {inst.type}</p>
                  </div>
                </div>
                <div className="flex gap-2">
                  <button onClick={() => { setSchedForm({ institute_id: inst.id, session_code: '', class_segment: '', class_day: '', time_window: '' }); setShowSchedModal(true); }} className="text-blue-600 hover:bg-blue-50 p-2 rounded-lg transition-colors flex items-center gap-2 text-xs font-bold">
                    <FaPlus /> Add Time
                  </button>
                  <button onClick={() => { setInstForm(inst); setShowInstModal(true); }} className="text-slate-400 hover:text-slate-600 p-2">
                    <FaEdit />
                  </button>
                  <button onClick={() => deleteInst(inst.id)} className="text-slate-400 hover:text-red-600 p-2">
                    <FaTrash />
                  </button>
                </div>
              </div>

              <div className="p-4">
                <table className="w-full text-left text-xs">
                  <thead>
                    <tr className="text-slate-400 uppercase tracking-widest font-bold border-b border-slate-100">
                      <th className="pb-3 px-2">Code</th>
                      <th className="pb-3 px-2">Segment</th>
                      <th className="pb-3 px-2">Day</th>
                      <th className="pb-3 px-2">Time</th>
                      <th className="pb-3 px-2 text-right">Action</th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-slate-50">
                    {inst.schedules.map(sched => (
                      <tr key={sched.id} className="hover:bg-slate-50">
                        <td className="py-3 px-2 font-mono text-slate-400">{sched.session_code}</td>
                        <td className="py-3 px-2 font-bold text-slate-700">{sched.class_segment}</td>
                        <td className="py-3 px-2 text-blue-600 font-bold">{sched.class_day}</td>
                        <td className="py-3 px-2 text-slate-500">{sched.time_window}</td>
                        <td className="py-3 px-2 text-right">
                          <button onClick={() => { setSchedForm(sched); setShowSchedModal(true); }} className="text-slate-300 hover:text-slate-600 p-1"><FaEdit /></button>
                          <button onClick={() => deleteSched(sched.id)} className="text-slate-300 hover:text-red-600 p-1 ml-1"><FaTrash /></button>
                        </td>
                      </tr>
                    ))}
                    {inst.schedules.length === 0 && (
                      <tr><td colSpan="5" className="py-8 text-center text-slate-400 italic">No time slots added yet.</td></tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          ))}
        </div>
      )}

      {/* Institute Modal */}
      {showInstModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4">
          <div className="bg-white rounded-2xl w-full max-w-md p-6 shadow-xl">
            <h3 className="text-lg font-bold mb-4">{instForm.id ? 'Edit' : 'Add'} Institute</h3>
            <form onSubmit={handleSaveInst} className="space-y-4">
              <div>
                <label className="block text-xs font-bold text-slate-500 mb-1">NAME</label>
                <input type="text" value={instForm.name} onChange={e => setInstForm({...instForm, name: e.target.value})} className="w-full border rounded-lg p-2 text-sm" required />
              </div>
              <div>
                <label className="block text-xs font-bold text-slate-500 mb-1">LOCATION</label>
                <input type="text" value={instForm.location} onChange={e => setInstForm({...instForm, location: e.target.value})} className="w-full border rounded-lg p-2 text-sm" required />
              </div>
              <div className="flex gap-4">
                <div className="flex-1">
                  <label className="block text-xs font-bold text-slate-500 mb-1">TYPE</label>
                  <select value={instForm.type} onChange={e => setInstForm({...instForm, type: e.target.value})} className="w-full border rounded-lg p-2 text-sm">
                    <option value="physical">Physical</option>
                    <option value="online">Online</option>
                  </select>
                </div>
                <div className="flex-1">
                  <label className="block text-xs font-bold text-slate-500 mb-1">ORDER</label>
                  <input type="number" value={instForm.sort_order} onChange={e => setInstForm({...instForm, sort_order: e.target.value})} className="w-full border rounded-lg p-2 text-sm" />
                </div>
              </div>
              <div className="flex justify-end gap-2 mt-6">
                <button type="button" onClick={() => setShowInstModal(false)} className="px-4 py-2 text-sm font-bold text-slate-400">Cancel</button>
                <button type="submit" className="bg-orange-500 text-white px-6 py-2 rounded-lg text-sm font-bold">Save</button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Schedule Modal */}
      {showSchedModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4">
          <div className="bg-white rounded-2xl w-full max-w-md p-6 shadow-xl">
            <h3 className="text-lg font-bold mb-4">{schedForm.id ? 'Edit' : 'Add'} Time Slot</h3>
            <form onSubmit={handleSaveSched} className="space-y-4">
              <div>
                <label className="block text-xs font-bold text-slate-500 mb-1">SESSION CODE (e.g. #001)</label>
                <input type="text" value={schedForm.session_code} onChange={e => setSchedForm({...schedForm, session_code: e.target.value})} className="w-full border rounded-lg p-2 text-sm" />
              </div>
              <div>
                <label className="block text-xs font-bold text-slate-500 mb-1">CLASS SEGMENT (e.g. GRADE 9 - THEORY)</label>
                <input type="text" value={schedForm.class_segment} onChange={e => setSchedForm({...schedForm, class_segment: e.target.value})} className="w-full border rounded-lg p-2 text-sm" required />
              </div>
              <div>
                <label className="block text-xs font-bold text-slate-500 mb-1">DAY (e.g. SUNDAY)</label>
                <input type="text" value={schedForm.class_day} onChange={e => setSchedForm({...schedForm, class_day: e.target.value})} className="w-full border rounded-lg p-2 text-sm" required />
              </div>
              <div>
                <label className="block text-xs font-bold text-slate-500 mb-1">TIME WINDOW (e.g. 3:30 - 5:30 pm)</label>
                <input type="text" value={schedForm.time_window} onChange={e => setSchedForm({...schedForm, time_window: e.target.value})} className="w-full border rounded-lg p-2 text-sm" required />
              </div>
              <div className="flex justify-end gap-2 mt-6">
                <button type="button" onClick={() => setShowSchedModal(false)} className="px-4 py-2 text-sm font-bold text-slate-400">Cancel</button>
                <button type="submit" className="bg-orange-500 text-white px-6 py-2 rounded-lg text-sm font-bold">Save</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default ManageSchedules;
